import React, { PropsWithChildren, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { theme, useStyles } from './Loader.styles';
import { ThemeProvider } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircleOutline';

interface LoaderProps extends PropsWithChildren<any> {
  loaderType?: 'spinner' | 'itemDownloads';
  text?: string;
  isSuccess?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ loaderType = 'spinner', text = 'Pobieranie danych', isSuccess }) => {
  const classes = useStyles();

  const [isLoader, setIsLoader] = useState<boolean>(true);
  const handleOnClick = () => {
    if (isSuccess) {
      setIsLoader(false);
    }
  };

  return loaderType === 'spinner' && isLoader ? (
    <div className={classes.container}>
      <div className={classes.badge}>
        <ThemeProvider theme={theme}>
          <CircularProgress className={classes.loader} />
        </ThemeProvider>
        <Typography className={classes.text}>{text}</Typography>
      </div>
    </div>
  ) : isLoader ? (
    <div className={classes.container} onClick={handleOnClick}>
      <div className={classes.badge}>
        <ThemeProvider theme={theme}>
          {isSuccess ? (
            <CheckCircleIcon className={classes.success} />
          ) : (
            <CircularProgress className={classes.loader} />
          )}
        </ThemeProvider>
        <Typography className={classes.text}>{text}</Typography>
      </div>
    </div>
  ) : null;
};
export default Loader;
